import { FC } from 'react'
import { FormControl, FormLabel } from 'react-bootstrap'
import { warehouseOptions, WareHouseSearchOptions } from 'shared/models/Enum'

interface IProps {
  warehouseId: number
  handleProductGroupCodeChange: (productGroupCode: string) => void
  handleFustCodeChange: (fustCode: string) => void
  handleWarehouseChange: (warehouseId: number) => void
}

const SearchForm: FC<IProps> = ({
  warehouseId,
  handleProductGroupCodeChange,
  handleFustCodeChange,
  handleWarehouseChange,
}) => {
  return (
    <form>
      <table className='selectie'>
        <thead>
          <tr>
            <th className='selectie-label'>
              <FormLabel htmlFor='productGroupCode'>
                Productgroepcode (begint met):
              </FormLabel>
            </th>
            <th className='selectie-label'>
              <FormLabel htmlFor='fustCode'>Fustcode:</FormLabel>
            </th>
            <th className='selectie-label'>
              <FormLabel htmlFor='warehouseId'>Vestiging:</FormLabel>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <FormControl
                type='text'
                name='productGroupCode'
                id='productGroupCode'
                placeholder='bijv. 1030'
                onChange={e => handleProductGroupCodeChange(e.target.value)}
              />
            </td>
            <td>
              <FormControl
                type='text'
                name='fustCode'
                id='fustCode'
                placeholder='bijv. 560'
                onChange={e => handleFustCodeChange(e.target.value)}
              />
            </td>
            <td>
              <FormControl
                as='select'
                id='warehouseId'
                name='warehouseId'
                onChange={e => handleWarehouseChange(Number(e.target.value))}
                defaultValue={warehouseId.toString()}
              >
                <option key='default' value='-1' />
                {warehouseOptions.map(warehouse => (
                  <option key={warehouse} value={warehouse}>
                    {WareHouseSearchOptions[warehouse]}
                  </option>
                ))}
              </FormControl>
            </td>
          </tr>
        </tbody>
      </table>
    </form>
  )
}

export default SearchForm
